import type { ArtifactCanvasConfig } from '@/components/artifact/artifact-canvas-context'

import { DocumentCanvas } from './document-canvas'
import { displayDocumentTitle } from './documents-shared'

type OpenDocumentCanvasArgs = {
  documentId: string
  /** List row title when known — canvas chrome only; editor hydrates from API. */
  titleHint?: string
  openCanvas: (config: ArtifactCanvasConfig) => void
  closeCanvas: () => void
  onDeleted?: () => void
  onDuplicated?: (newDocumentId: string) => void
}

export function openDocumentCanvas({
  documentId,
  titleHint = '',
  openCanvas,
  closeCanvas,
  onDeleted,
  onDuplicated,
}: OpenDocumentCanvasArgs) {
  openCanvas({
    preventAutoFocus: true,
    title: displayDocumentTitle(titleHint),
    content: (
      <DocumentCanvas
        key={documentId}
        documentId={documentId}
        onClose={closeCanvas}
        onDeleted={onDeleted}
        onDuplicated={onDuplicated}
      />
    ),
  })
}
